import { useEffect, useMemo } from "react";
import { AnimatePresence, motion } from "motion/react";
import { hapticSuccess } from "@/lib/telegram";

const COLORS = ["#4f8dfd", "#a855f7", "#22c55e", "#f59e0b", "#ec4899"];

export function Celebration({
  open,
  title,
  subtitle,
  onDone,
}: {
  open: boolean;
  title: string;
  subtitle: string;
  onDone: () => void;
}) {
  const pieces = useMemo(
    () =>
      Array.from({ length: 42 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 0.6,
        duration: 1.8 + Math.random() * 1.4,
        color: COLORS[i % COLORS.length],
        size: 6 + Math.random() * 8,
      })),
    [],
  );

  useEffect(() => {
    if (!open) return;
    hapticSuccess();
    const timer = window.setTimeout(onDone, 3200);
    return () => window.clearTimeout(timer);
  }, [open, onDone]);

  return (
    <AnimatePresence>
      {open ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[80] flex items-center justify-center bg-background/70 backdrop-blur-xl"
          onClick={onDone}
        >
          {pieces.map((piece) => (
            <span
              key={piece.id}
              aria-hidden
              className="absolute top-0 rounded-[2px]"
              style={{
                left: `${piece.left}%`,
                width: piece.size,
                height: piece.size * 1.6,
                backgroundColor: piece.color,
                animation: `confetti-fall ${piece.duration}s ${piece.delay}s ease-in forwards`,
              }}
            />
          ))}
          <motion.div
            initial={{ scale: 0.7, y: 30, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", stiffness: 200, damping: 18 }}
            className="glass mx-7 rounded-[2rem] px-8 py-10 text-center"
          >
            <div className="text-5xl">🎉</div>
            <h2 className="text-gradient mt-4 text-2xl font-extrabold">{title}</h2>
            <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>
          </motion.div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}